import { useState } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import gastro from 'helpers/gastro';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import axios from 'helpers/gastro';
import { get, post } from 'helpers/apiHelpers';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { remove } from 'helpers/apiHelpers';
import moment from 'moment';
import { toast } from 'react-toastify';

import importCSVExample from '../exampleFiles/import-csv-example.csv';
import importCSVExamplePrices from '../exampleFiles/import-csv-example-prices.csv';
import importCSVExampleTranslations from '../exampleFiles/import-csv-example-translations.csv';
import importCSVExamplePricesFi from '../exampleFiles/import-csv-example-prices-fi.csv';
import importCSVExampleFi from '../exampleFiles/import-csv-example-fi.csv';
import CustomRemoveBody from '../auixilaryFunctions/CustomRemoveBody';
import ListIngredientsView from './ListIngredients.view';

const ListIngredientsContainer = ({
  history,
  classes,
  i18n,
  multinational,
  t,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
  brand,
}) => {
  const [state, setState] = useState({
    openedModal: false,
    modalMode: '',
    file: null,
    isImporting: false,
    importButtonClicked: false,
    checkedRowIds: [],
    isConfirmModalOpened: false,
    refreshList: false,
    recipesWithIngredientArray: [],
    exporting: false,
  });

  const { language } = i18n;
  const { currency } = multinational;

  const newSize = () => history.push(`${window.location.pathname}/add`);

  const renderCustomRemoveBody = props => (
    <CustomRemoveBody {...props} classes={classes} />
  );

  const toggleModal = mode => {
    setState(prevState => ({
      ...prevState,
      openedModal: !prevState.openedModal,
      modalMode: mode,
    }));
  };

  const importIngredients = () => {
    setState(prev => ({ ...prev, importButtonClicked: true }));
    // eslint-disable-next-line no-use-before-define, promise/prefer-await-to-then -- FIXME
    uploadFile(state.file).then(file => {
      // eslint-disable-next-line no-use-before-define -- FIXME
      postImporterTask(file, state.modalMode);
    });
  };

  const postImporterTask = (file, mode) => {
    setState(prev => ({ ...prev, isImporting: true }));

    const data = {
      type:
        // eslint-disable-next-line no-nested-ternary -- FIXME
        mode === 'ingredients'
          ? 'INGREDIENTS'
          : mode === 'translations'
          ? 'INGREDIENT_TRANSLATIONS'
          : 'INGREDIENT_PRICES',
      file: file['@id'],
      config: {
        skipHeader: true,
        delimiter: ';',
      },
    };

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    post('/importer-tasks', data).then(
      () => {
        setState(prev => ({
          ...prev,
          openedModal: false,
          file: null,
          importButtonClicked: false,
        }));
        setState(prev => ({ ...prev, isImporting: false }));
        return toast.success(
          `${t('form.importerInfo26')} ${t('form.importerInfo23')}`
        );
      },
      () => {
        setState(prev => ({ ...prev, isImporting: false }));
        return toast.error(t('form.importerInfo25'));
      }
    );
  };

  const uploadFile = async file => {
    const data = new FormData();
    data.append('file', file);

    const response = await gastro.post('/media', data);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    return new Promise((resolve, reject) => {
      resolve(response.data);
    });
  };

  // eslint-disable-next-line no-shadow -- FIXME
  const loadExample = language => {
    switch (language) {
      case 'fi':
        return importCSVExampleFi;
      default:
        return importCSVExample;
    }
  };

  // eslint-disable-next-line no-shadow -- FIXME
  const loadPricesExample = language => {
    switch (language) {
      case 'fi':
        return importCSVExamplePricesFi;
      default:
        return importCSVExamplePrices;
    }
  };

  // eslint-disable-next-line no-shadow -- FIXME
  const loadTranslationsExample = language => {
    switch (language) {
      case 'fi':
        return importCSVExampleTranslations;
      default:
        return importCSVExampleTranslations;
    }
  };

  const refreshList = () => {
    setState(prevState => ({
      ...prevState,
      refreshList: !prevState.refreshList,
    }));
  };

  const massDeleteHandleMultipleCheckboxes = array => {
    setState(prevState => ({ ...prevState, checkedRowIds: array }));
  };

  const massDeleteHandleSingleCheckbox = id => {
    const checkedIdsUpdated = [...state.checkedRowIds];
    const checkedIdIndex = checkedIdsUpdated.indexOf(id);
    if (checkedIdIndex >= 0) {
      checkedIdsUpdated.splice(checkedIdIndex, 1);
    } else {
      checkedIdsUpdated.push(id);
    }
    setState(prevState => ({
      ...prevState,
      checkedRowIds: checkedIdsUpdated,
    }));
  };

  const checkForOccurrenceIngredientWithDishes = () => {
    const recipesWithIngredientArray = [];
    let url = '/recipes?';
    state.checkedRowIds.forEach((id, index) => {
      if (index === 0) {
        url = url.concat(`ingredients.ingredient.id[]=${id}`);
      } else {
        url = url.concat(`&ingredients.ingredient.id[]=${id}`);
      }
    });

    get(url, {
      pagtination: false,
      itemsPerPage: 200,
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(recipe => {
      // eslint-disable-next-line no-shadow -- FIXME
      recipe['hydra:member'].map(recipe => {
        recipesWithIngredientArray.push(`${recipe.workName} `);
        return null;
      });
      setState(prevState => ({
        ...prevState,
        recipesWithIngredientArray,
        isConfirmModalOpened: true,
      }));
    });
  };

  const massDeleteSubmit = () => {
    setState(prevState => ({
      ...prevState,
      isConfirmModalOpened: false,
      isDeleting: false,
    }));

    let url = '/ingredients?';
    state.checkedRowIds.forEach((id, index) => {
      if (index === 0) {
        url = url.concat(`id[]=${id}`);
      } else {
        url = url.concat(`&id[]=${id}`);
      }
    });
    url = url.concat('&removeAllAction=true');
    remove(url)
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        toast.success(t('dictionary.massdelete.success'));
        refreshList();
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => {
        toast.error(t('dictionary.massdelete.error'));
      });
  };

  const exportPrices = () => {
    const fileName = 'prices_export_file';
    const endpoint = '/ingredient-prices-export';
    const format = 'xlsx';
    const date = moment().format('DD-MM-YYYY_HH-mm');
    const exportedName = `${fileName}_${date}`;

    const params = {
      'order[id]': 'DESC',
      properties: ['id', 'name', 'workName', 'shoppingName', 'price'],
    };

    axios
      .get(`${endpoint}.${format}`, {
        responseType: 'blob',
        params,
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${exportedName}.${format}`);

          document.body.appendChild(link);
          link.click();
          setState(prev => ({ ...prev, exporting: false }));
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks, @typescript-eslint/no-unused-vars -- FIXME
        error => {
          setState(prev => ({ ...prev, exporting: false }));
          return toast.error(t('errors.dataExportFailed'));
        }
      );
  };

  const exportTranslations = () => {
    const fileName = 'translations_export_file';
    const endpoint = '/ingredient-translations-export';
    const format = 'xlsx';
    const date = moment().format('DD-MM-YYYY_HH-mm');
    const exportedName = `${fileName}_${date}`;

    const params = {
      'order[id]': 'DESC',
    };

    axios
      .get(`${endpoint}.${format}`, {
        responseType: 'blob',
        params,
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${exportedName}.${format}`);

          document.body.appendChild(link);
          link.click();
          setState(prev => ({ ...prev, exporting: false }));
        },
        () => {
          setState(prev => ({ ...prev, exporting: false }));
          return toast.error(t('errors.dataExportFailed'));
        }
      );
  };

  const props = {
    classes,
    state,
    setState,
    t,
    language,
    currency,
    newSize,
    renderCustomRemoveBody,
    toggleModal,
    importIngredients,
    loadExample,
    loadPricesExample,
    loadTranslationsExample,
    massDeleteHandleMultipleCheckboxes,
    checkForOccurrenceIngredientWithDishes,
    massDeleteSubmit,
    exportPrices,
    exportTranslations,
    massDeleteHandleSingleCheckbox,
  };
  return <ListIngredientsView props={props} />;
};

const enhance = compose(
  connect(
    ({
      Brands: {
        brand: { multinational },
      },
    }) => ({ multinational })
  ),
  withStyles(buttonsStyle),
  withTranslation()
);

export default enhance(ListIngredientsContainer);
